export default function LegalContent() {
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="space-y-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-6">
              Éditeur du site
            </h2>
            <div className="bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8 space-y-3 text-sm md:text-base text-[#243038]">
              <p><strong className="text-[#1E3A47]">Dénomination sociale :</strong> DF PRO, SAS</p>
              <p><strong className="text-[#1E3A47]">SIREN :</strong> 984 775 262</p>
              <p><strong className="text-[#1E3A47]">SIRET :</strong> 984 775 262 00020</p>
              <p><strong className="text-[#1E3A47]">TVA intracommunautaire :</strong> FR96 984 775 262</p>
              <p><strong className="text-[#1E3A47]">Code NAF :</strong> 43.32A (Travaux d'installation électrique dans tous locaux)</p>
              <p><strong className="text-[#1E3A47]">Siège social :</strong> 100 Route de Nîmes, 30132 Caissargues</p>
              <p><strong className="text-[#1E3A47]">Atelier :</strong> 82 rue de Heidenberg, 67200 Strasbourg</p>
              <p><strong className="text-[#1E3A47]">Téléphone :</strong> <a href="tel:0374471036" className="text-[#FF6B4A] hover:underline">03 74 47 10 36</a></p>
              <p><strong className="text-[#1E3A47]">Directeur de la publication :</strong> le représentant légal de DF PRO</p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-6">
              Hébergeur
            </h2>
            <div className="bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-6 md:p-8 space-y-3 text-sm md:text-base text-[#243038]">
              <p><strong className="text-[#1E3A47]">Dénomination :</strong> OVH SAS</p>
              <p><strong className="text-[#1E3A47]">Adresse :</strong> 2 rue Kellermann, 59100 Roubaix</p>
              <p><strong className="text-[#1E3A47]">Téléphone :</strong> 1007</p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-6">
              Propriété intellectuelle
            </h2>
            <div className="text-sm md:text-base text-[#243038] leading-relaxed space-y-3">
              <p>
                L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de DF PRO, sauf mention contraire. Toute reproduction, représentation, modification, publication, adaptation ou exploitation, totale ou partielle, du contenu de ce site est strictement interdite sans l'autorisation préalable écrite de DF PRO.
              </p>
              <p>
                Toute exploitation non autorisée constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
              </p>
              <p>
                Les marques et logos figurant sur ce site sont des marques déposées par leurs propriétaires respectifs. Toute reproduction ou utilisation sans autorisation est interdite.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-6">
              Données personnelles (RGPD)
            </h2>
            <div className="text-sm md:text-base text-[#243038] leading-relaxed space-y-3">
              <p>
                DF PRO collecte et traite les données personnelles de ses utilisateurs dans le respect de la réglementation applicable, notamment le Règlement Général sur la Protection des Données (RGPD) et la loi Informatique et Libertés modifiée.
              </p>
              <p>
                Les données collectées via les formulaires de contact sont utilisées uniquement pour répondre aux demandes de devis et de renseignements. Elles ne sont ni vendues ni cédées à des tiers.
              </p>
              <p>
                Conformément aux articles 15 à 22 du RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation du traitement, de portabilité et d'opposition concernant vos données personnelles. Pour exercer ces droits, contactez-nous à l'adresse de l'atelier : 82 rue de Heidenberg, 67200 Strasbourg.
              </p>
              <p>
                Pour plus de détails, consultez notre <a href="/politique-confidentialite" className="text-[#FF6B4A] hover:underline">politique de confidentialité</a>.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-6">
              Cookies
            </h2>
            <div className="text-sm md:text-base text-[#243038] leading-relaxed space-y-3">
              <p>
                Ce site utilise des cookies techniques nécessaires à son bon fonctionnement et à la navigation. Ces cookies ne collectent pas de données personnelles à des fins de suivi ou de publicité.
              </p>
              <p>
                À l'exception des cookies strictement nécessaires, vous pouvez à tout moment modifier vos préférences de cookies via votre navigateur. La suppression des cookies peut affecter certaines fonctionnalités du site.
              </p>
            </div>
          </div>

          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-6">
              Limitation de responsabilité
            </h2>
            <div className="text-sm md:text-base text-[#243038] leading-relaxed space-y-3">
              <p>
                DF PRO s'efforce de garantir l'exactitude et la mise à jour des informations diffusées sur ce site. Cependant, DF PRO ne peut être tenu responsable d'erreurs, d'omissions ou d'indisponibilité temporaire du site.
              </p>
              <p>
                Les liens hypertextes présents sur ce site peuvent renvoyer vers des pages externes. DF PRO n'assume aucune responsabilité quant au contenu de ces sites tiers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}